<template>
  <page-header-wrapper>
    <!-- 关键：把整个卡片内容包进 table-page-search-wrapper -->
    <div class="table-page-search-wrapper">
      <a-card :bordered="false">
        <!-- 1. 条件搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @submit.prevent="handleQuery">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24" v-if="!categoryId">
                <a-form-item label="维修分类">
                  <a-select
                    show-search
                    :allowClear="true"
                    v-model="queryParam.categoryId"
                    placeholder="请选择"
                    option-filter-prop="children"
                    :filter-option="filterOption"
                  >
                    <a-select-option v-for="d in cateList" :key="d.id">
                      {{ d.categoryName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="维修名称">
                  <a-input v-model="queryParam.prodName" placeholder="请输入" allow-clear @keyup.enter="handleQuery" />
                </a-form-item>
              </a-col>
              <template v-if="advanced">
                <a-col :md="6" :sm="24">
                  <a-form-item label="上架状态">
                    <a-select v-model="queryParam.status" style="width: 100%" allow-clear placeholder="请选择">
                      <a-select-option
                        v-for="(d, index) in dict.type['sys_normal_disable']"
                        :key="index"
                        :value="d.value"
                      >
                        {{ d.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </template>
              <a-col :md="(!advanced && 6) || 24" :sm="24">
                <span
                  class="table-page-search-submitButtons"
                  :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
                >
                  <a-button type="primary" @click="handleQuery"> <a-icon type="search" />查询 </a-button>
                  <a-button style="margin-left: 8px" @click="resetQuery"> <a-icon type="redo" />重置 </a-button>
                  <a style="margin-left: 8px" @click="toggleAdvanced">
                    {{ advanced ? '收起' : '展开' }}
                    <a-icon :type="advanced ? 'up' : 'down'" />
                  </a>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 2. 操作按钮 -->
        <div class="table-operations">
          <template v-if="isOperate">
            <a-button
              v-hasPermi="['upkeep:prod:add']"
              type="primary"
              @click="$refs.createForm.handleAdd(queryParam.categoryId)"
            >
              <a-icon type="plus" />新增
            </a-button>
            <a-button
              v-hasPermi="['upkeep:prod:edit']"
              type="primary"
              :disabled="single"
              @click="$refs.createForm.handleUpdate(undefined, ids)"
            >
              <a-icon type="edit" />修改
            </a-button>
            <a-button v-hasPermi="['upkeep:prod:remove']" type="danger" :disabled="multiple" @click="handleDelete">
              <a-icon type="delete" />删除
            </a-button>
          </template>
          <table-setting
            :style="{ float: 'right' }"
            table-size.sync="Large"
            v-model="columns"
            :refresh-loading="loading"
            @refresh="getList"
          />
        </div>
        <!-- 3. 表格 -->
        <a-table
          :loading="loading"
          row-key="id"
          :columns="columns"
          :data-source="list"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :pagination="false"
          :bordered="false"
        >
          <!-- 各插槽略，与原文件完全一致 -->
          <span slot="pic" slot-scope="text, record">
            <div v-viewer>
              <img :src="$url + record.imgs[0]" alt="" style="width: 50px; height: 50px" />
            </div>
          </span>
          <span slot="putawayTime" slot-scope="text, record">
            {{ parseTime(record.putawayTime) }}
          </span>
          <span slot="brief" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="record.brief">
              <span>{{ record.brief }}</span>
            </a-tooltip>
          </span>
          <span slot="status" slot-scope="text, record">
            <dict-tag :options="dict.type['goods_onsale']" :value="record.status" />
            <template v-if="categoryId">
              <a-tag v-if="record.status == 0" color="red">下架</a-tag>
              <a-tag v-else color="green">上架</a-tag>
            </template>
            <template v-else>
              <a-popconfirm
                ok-text="是"
                cancel-text="否"
                @confirm="confirmHandleStatus(record)"
                @cancel="cancelHandleStatus(record)"
              >
                <span slot="title">
                  确认<b>{{ record.status === 1 ? '下架' : '上架' }}</b
                  >吗?
                </span>
                <a-switch
                  v-hasPermi="['abm-integral:prod:edit']"
                  checked-children="上架"
                  un-checked-children="下架"
                  :checked="record.status == 1"
                />
              </a-popconfirm>
            </template>
          </span>
          <span slot="operation" slot-scope="text, record">
            <a
              v-if="record.status == 0"
              v-hasPermi="['upkeep:prod:edit']"
              @click="$refs.createForm.handleUpdate(record, undefined)"
            >
              修改
            </a>
            <a-divider
              v-if="record.status == 0"
              type="vertical"
              v-hasPermi="['upkeep:prod:remove', 'upkeep:prod:query']"
            />
            <a-dropdown v-hasPermi="['upkeep:prod:remove', 'upkeep:prod:query']">
              <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                <a-icon type="double-right" />
                更多
              </a>
              <a-menu slot="overlay">
                <a-menu-item v-hasPermi="['upkeep:prod:query']">
                  <a v-hasPermi="['upkeep:prod:query']" @click="$refs.goodsDetail.init(record, 1)">详情</a>
                </a-menu-item>
                <a-menu-item v-hasPermi="['upkeep:prod:remove']" v-if="record.status == 0">
                  <a v-hasPermi="['upkeep:prod:remove']" @click="handleDelete(record)">删除</a>
                </a-menu-item>
                <!-- <a-menu-item v-hasPermi="['2627d9a98c563c56cc5cbe56ac95d806b:0:b']">
                  <a v-hasPermi="['2627d9a98c563c56cc5cbe56ac95d806b:0:b']" @click="openServicePricing(record)">
                    服务项管理
                  </a>
                </a-menu-item> -->
                <!-- <a-menu-item v-hasPermi="['upkeep:prod-sku-material-item:list']">
                  <a v-hasPermi="['upkeep:prod-sku-material-item:list']" @click="openMaterialItem(record)">
                    材料项管理
                  </a>
                </a-menu-item> -->
              </a-menu>
            </a-dropdown>
          </span>
        </a-table>
        <!-- 4. 分页 -->
        <a-pagination
          class="ant-table-pagination"
          show-size-changer
          show-quick-jumper
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :show-total="(total) => `共 ${total} 条`"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </a-card>
    </div>
    <!-- 5. 弹层/子组件 -->
    <create-form ref="createForm" :cate-list="cateList" @ok="getList" />
    <goods-detail ref="goodsDetail" @ok="getList" />
    <ServicePricingCreateForm ref="serpri"></ServicePricingCreateForm>
    <ServicePricingDrawer ref="servicePricingDrawer" :isOperate="true" />
    <!-- 材料项管理抽屉 -->
    <MaterialItemDrawer ref="materialItemDrawer" :isOperate="true" />
  </page-header-wrapper>
</template>
<script>
import ServicePricingCreateForm from './modules/ServicePricingCreateForm'
import MaterialItemDrawer from './modules/MaterialItemDrawer'
import CreateForm from './modules/CreateForm'
import goodsDetail from './modules/goodsDetail'
// import { tableMixin } from '@/store/table-mixin'
// import * as goods from '@/api/pressure/goods'
import ServicePricingDrawer from './modules/ServicePricingDrawer'
import { categoryList } from '@/api/maintenance/classification/index.js'
import { fetchList, delObj, prodUnmount, prodInventory } from '@/api/maintenance/product/index.js'
export default {
  name: 'Post',
  components: {
    // CreatePform,
    CreateForm,
    goodsDetail,
    ServicePricingCreateForm,
    ServicePricingDrawer,
    MaterialItemDrawer,
  },
  // mixins: [tableMixin],
  dicts: ['sys_normal_disable'],
  props: {
    isOperate: {
      type: Boolean,
      default: true,
    },
    categoryId: {
      type: [String, Number],
      default: undefined,
    },
  },
  data() {
    return {
      list: [],
      dataFrom: {},
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      stocks: '',
      pagetype: 1, // 1商品列表 2新增编辑商品页面
      // tableSize: 'small',
      // tableBordered: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
        categoryId: undefined,
        sortOrder: 'ASCEND',
        sortField: 'sort',
      },
      cateList: [],
      columns: [
        {
          title: '维修分类',
          dataIndex: 'categoryName',
          ellipsis: true,
          align: 'left',
          width: 200,
          scopedSlots: { customRender: 'categoryName' },
        },
        {
          title: '产品名称',
          dataIndex: 'prodName',
          ellipsis: true,
          align: 'left',
          width: 200,
          scopedSlots: { customRender: 'prodName' },
        },
        {
          title: '产品图片',
          dataIndex: 'pic',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'pic' },
        },
        {
          title: '维修描述',
          dataIndex: 'brief',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'brief' },
        },
        // {
        //   title: '规格',
        //   dataIndex: 'spec_type',
        //   scopedSlots: { customRender: 'spec_type' },
        //   align: 'center',
        //   width: 80,
        // },
        {
          title: '上架状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center',
        },
        {
          title: '上架时间',
          dataIndex: 'putawayTime',
          scopedSlots: { customRender: 'putawayTime' },
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    this.queryParam.categoryId = this.categoryId
    if (this.categoryId) {
      this.columns.pop()
    } else {
      this.getClass()
    }
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    addRepairProduct(e) {
      this.$refs.serpri.handleAdd(e)
    },
    openMaterialItem(record) {
      this.$refs.materialItemDrawer.open(record)
    },
    openServicePricing(record) {
      this.$refs.servicePricingDrawer.open(record)
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 查询商品分类
    getClass() {
      categoryList().then((res) => {
        this.cateList = res.data.records
      })
    },
    // 点击增加库存
    handleStock(e) {
      // if (this.categoryId) return this.$message.error('没权限进行操作')
      e.isStocks = !e.isStocks
      this.dataFrom = e
      this.$forceUpdate()
    },
    // 回车保存
    handleStocks() {
      if (!this.stocks) return this.$message.error('请输入库存数量')
      prodInventory({ count: this.stocks, id: this.dataFrom.id }).then((res) => {
        this.$message.success('操作成功')
        this.getList()
        this.stocks = ''
      })
    },
    /** 查询部门列表 */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        response.data.records.forEach((item) => {
          item.imgs = item.imgs ? JSON.parse(item.imgs) : []
        })
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
        categoryId: undefined,
        sortOrder: 'ASCEND',
        sortField: 'sort',
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.postId)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 新增按钮操作 */
    handleAdd() {
      // this.$router.push({
      //   path: '/pressure/goods/goodsForm',
      //   params: {
      //     id: undefined,
      //     formTitle: '添加商品',
      //   },
      // })
    },
    /** 编辑商品信息 **/
    handleUpdate(row) {
      const id = row ? row.id : ''
      this.$router.push({
        path: '/mall/goodsForm',
        params: {
          id: id,
          formTitle: '修改商品',
        },
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const that = this
      let ids = []

      if (row.id) {
        // 单条删除
        ids = [{ id: row.id }]
      } else {
        // 批量删除
        ids = this.selectedRows
          .map((item) => {
            const id = item.id ?? item.postId
            return { id }
          })
          .filter((item) => item.id !== undefined)
      }

      console.log('删除参数:', ids)

      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
      })
    },
    confirmHandleStatus(info) {
      prodUnmount({ id: info.id }).then((res) => {
        this.$message.success('操作成功')
        this.getList()
      })
    },
    cancelHandleStatus() {},
  },
}
</script>
